.root {
  align-items: center;
  border-top: 1px solid var(--color-border);
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
  padding: 12px 20px;
}

.hints {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.hint {
  align-items: center;
  color: var(--color-muted);
  display: inline-flex;
  font-size: 12px;
  gap: 6px;
}

.kbd {
  background: var(--color-secondary);
  border: 1px solid var(--color-border);
  border-radius: 4px;
  color: var(--color-foreground);
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  min-width: 22px;
  padding: 2px 6px;
  text-align: center;
}

.status {
  color: var(--color-muted);
  font-size: 12px;
  font-weight: 500;
}

.status-is-thinking {
  color: var(--color-primary);
}

.status-is-listening {
  color: var(--color-primary);
}

.status-is-error {
  color: var(--color-destructive);
}
